<script lang="ts">
  import { login, auth } from '$lib/stores/Auth.svelte';
	import { onMount } from 'svelte';
  $effect(() => {
  // $inspect.trace must be the first statement of a function body
  $inspect.trace();
  const _l = auth;
	});
  onMount(() => {
    // Redirect to login immediately
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        login();
      });
    } else {
      login();
    }
  });

</script>

<p>Redirecting to login…</p>
